<app-title-percentage [title]="title" [percentage]="(praticaProgressService.progress$ | async)?.['presentation-sheet']">
</app-title-percentage>


<smart-form [fields]="fields"></smart-form>

<!-- <h2>Esposizioni in essere</h2>
<app-presentation-sheet-table [idScheda]="idScheda"></app-presentation-sheet-table> -->



<app-budget-details-table *ngIf="personaGiuridica?.tipoSoggetto == 'SC'" [idScheda]="idScheda">
</app-budget-details-table>